import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_Services, API_Ingetration_Channels } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ServiceListItem from './components/ServiceListItem';
import AddNewService from './components/AddNewService';
import IntlMessages from '../../../../../helpers/IntlMessages';
import TemplateServiceButton from './components/TemplateServiceButton';
import AddonsAndUpsells_image from '../../../../../assets/addons_and_upsells.png';

function ServiceOrder({ propertyId, locale }) {
  const [serviceList, setServicesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [orderBy, setOrderBy] = useState({ column: 'Title', label: 'Title' });
  const [search, setSearch] = useState('');
  const [isHostedPage, setIsHostedPage] = useState(false);
  const orderOptions = [
    { column: 'Title', label: 'Title' },
    { column: 'Type', label: 'Type' },
    { column: 'Response', label: 'Response' },
    { column: 'Status', label: 'Status' },
  ];
  useEffect(() => {
    LoadData();
    let body = {
      channels: ['GuestServiceStandAlonePage']
    }
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body
    }).then((res) => {

      const serviceHostedPageIntegration = res.data.filter(
        (k) => k.channel === 'GuestServiceStandAlonePage' && k.properties !== undefined && k.properties.includes(propertyId)
      );
      if (serviceHostedPageIntegration.length > 0)
        setIsHostedPage(true);
    });
  }, [propertyId, orderBy, search]);

  const LoadData = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Services}?propertyId=${propertyId}&lang=${locale}&orderBy=${orderBy.column}&search=${search}`,
    })
      .then((res) => {
        let service = res.data.filter((item) => item.serviceType === "ServiceOrder");
        console.log(res.data, service);
        setServicesList(service);
        setLoading(false);
      })
      .catch((err) => console.log('err', err));
  };

  const toggleModal = () => {
    setVisible(!visible);
  };

  const changeOrderBy = (column) => {
    setOrderBy(orderOptions.find((x) => x.column === column));
  };

  const onSearchKey = (e) => {
    if (e.key === 'Enter') {
      setSearch(e.target.value.toLowerCase());
    }
  };

  if (loading) {
    return <div className="loading" />;
  }

  return (
    <Fragment>
      <Row className="app-row survey-app">
        <Colxx xxs="12">
          <div className="mb-2">
            <h1><IntlMessages id="menu.guestservice" /></h1>
            {!loading && (
              <Fragment>
                <div className="text-zero top-right-button-container">
                  <Button
                    color="primary"
                    size="lg"
                    className="top-right-button mr-1"
                    onClick={toggleModal}
                  >
                    Add New
                  </Button>
                  <TemplateServiceButton LoadData={LoadData} isServiceOrder={true} />
                </div>
              </Fragment>
            )}
          </div>
          <div className="mb-2">
            <div className="d-block d-md-inline-block">
              <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                <DropdownToggle caret color="outline-dark" size="xs">
                  <IntlMessages id="pages.orderby" />
                  {orderBy.label}
                </DropdownToggle>
                <DropdownMenu>
                  {orderOptions.map((order, index) => {
                    return (
                      <DropdownItem
                        key={index}
                        onClick={() => changeOrderBy(order.column)}
                      >
                        {order.label}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
              <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                <input className='input_sty'
                  type="text"
                  name="keyword"
                  id="search"
                  placeholder="Search"
                  onKeyPress={(e) => onSearchKey(e)}
                />
              </div>
            </div>
          </div>
        </Colxx>
      </Row>
      <Separator className="mb-5" />
      <Row>
        {!loading ? (
          serviceList.length > 0 ? serviceList.map((item, index) => {
            return (
              <ServiceListItem
                key={`service_item_${index}`}
                item={item}
                toggleModal={toggleModal}
                isHostedPage={isHostedPage}
                isServiceOrder={true}
              />
            );
          }) : (
            <Fragment>
              <div style={{
                position: 'absolute',
                left: '40%',
                padding: "10px"
              }}>
                <div>
                  <img
                    src={AddonsAndUpsells_image}
                    alt="Addons And Upsells"
                    style={{ maxWidth: '400px' }}
                  />
                </div>
                <div style={{
                  position: "relative",
                  bottom: "60px",
                  padding: "20px"
                }}>
                  <Button
                    color="primary"
                    size="lg"
                    className="top-right-button mr-1"
                    onClick={toggleModal}
                  >
                    Add New
                  </Button>
                  <TemplateServiceButton LoadData={LoadData} />
                </div>
              </div>
            </Fragment>
          )
        ) : (
          <div className="loading" />
        )}
      </Row>

      <AddNewService
        toggleModal={toggleModal}
        formLabel="Create a New"
        visible={visible}
        isServiceOrder={true}
      />
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale
  };
};

export default injectIntl(connect(mapStateToProps, {})(ServiceOrder));
